export var PlayerRank;
(function (PlayerRank) {
    PlayerRank[PlayerRank["Recruit"] = 0] = "Recruit";
    PlayerRank[PlayerRank["Pilot"] = 1] = "Pilot";
    PlayerRank[PlayerRank["Lieutenant"] = 2] = "Lieutenant";
    PlayerRank[PlayerRank["Commander"] = 3] = "Commander";
    PlayerRank[PlayerRank["Captain"] = 4] = "Captain";
    PlayerRank[PlayerRank["Admiral"] = 5] = "Admiral";
    PlayerRank[PlayerRank["FleetAdmiral"] = 6] = "FleetAdmiral";
    PlayerRank[PlayerRank["Legend"] = 7] = "Legend";
})(PlayerRank || (PlayerRank = {}));
export function getRankForLevel(level) {
    if (level >= 100)
        return PlayerRank.Legend;
    if (level >= 86)
        return PlayerRank.FleetAdmiral;
    if (level >= 71)
        return PlayerRank.Admiral;
    if (level >= 51)
        return PlayerRank.Captain;
    if (level >= 31)
        return PlayerRank.Commander;
    if (level >= 16)
        return PlayerRank.Lieutenant;
    if (level >= 6)
        return PlayerRank.Pilot;
    return PlayerRank.Recruit;
}
/**
 * Level beyond which the original (untouched) XP curve applies. Below it
 * the requirement is discounted so new pilots reach the first few levels
 * inside their opening session — production data showed the vast majority
 * of accounts never crossed the old 282-XP level-1→2 wall and churned in a
 * single session.
 */
const EARLY_LEVEL_RAMP_UNTIL = 8;
/**
 * In-level XP needed to advance *into* `level` (i.e. the cost of the
 * `level-1 → level` step).
 *
 * The baseline is `100 * level^1.5`. For the first {@link
 * EARLY_LEVEL_RAMP_UNTIL} levels we multiply that baseline by a factor
 * that ramps from 0.4 (level 2) up to 1.0 (level 8), front-loading early
 * progression without changing mid/late-game pacing. The discount fades
 * smoothly and the per-level cost stays monotonically increasing, so the
 * curve has no discontinuity at the hand-off.
 *
 * This is a PvE progression knob and is identical for every race/ship, so
 * it does not affect PvP parity (see AGENTS.md §5).
 */
export function xpRequiredForLevel(level) {
    const base = 100 * Math.pow(level, 1.5);
    if (level >= EARLY_LEVEL_RAMP_UNTIL)
        return Math.floor(base);
    const t = (level - 1) / (EARLY_LEVEL_RAMP_UNTIL - 1);
    const factor = 0.3 + 0.7 * t;
    return Math.floor(base * factor);
}
export function totalXpForLevel(level) {
    let total = 0;
    for (let i = 1; i <= level; i++) {
        total += xpRequiredForLevel(i);
    }
    return total;
}
//# sourceMappingURL=player.js.map